import styled from "styled-components";
import { sizePx } from "../../../utils/devices";

export const MenuContainer = styled.div<{ isOpen: boolean }>`
  box-shadow: 0px 5px 9px 3px #e7e7e7;
  border-radius: 1px;

  @media (max-width: ${sizePx.tablet}) {
    box-shadow: none;

    ${({ isOpen }) =>
      isOpen &&
      `position: fixed;
      translateX(-100%);
      height: 100vh;
      width: 100vw;
      background: rgba(0, 0, 0, 0.5);
      top: 0;
      left: 0;`}

    &::after {
      content: "Menu >";
      display: ${({ isOpen }) => (isOpen ? `none` : `inherit`)};
      float: left;
      background: ${({ theme }) => theme.colors.primary};
      color: white;
      padding: 10px;
      border-top-right-radius: 15px;
      border-bottom-right-radius: 15px;
      margin: 30px 0;
    }
  }
`;

export const MenuList = styled.ul<{ isOpen: boolean }>`
  @media (max-width: ${sizePx.tablet}) {
    display: ${({ isOpen }) => (isOpen ? `inherit` : `none`)};
    width: 70%;
    height: 100%;
    background: ${({ theme }) => theme.colors.secondary};
    padding: 5px 0;
  }
`;

export const MenuListItem = styled.li`
  margin-bottom: 2px;
  @media (max-width: ${sizePx.tablet}) {
    margin-bottom: 0;
  }
`;

export const MenuItemLink = styled.a<{
  isActive?: boolean;
}>`
  font-family: "Poppins", Helvetica, sans-serif;
  color: ${({ theme, isActive }) => (isActive ? "white" : theme.colors.dark)};
  background: ${({ theme, isActive }) =>
    isActive ? theme.colors.dark : theme.colors.secondary};
  display: block;
  line-height: 20px;
  padding: 20px;
  @media (max-width: ${sizePx.tablet}) {
    color: ${({ theme }) => theme.colors.light};
    font-size: 1rem;
    line-height: 1.2rem;
    padding: 15px 10px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.dark};
  }
  &:hover {
    cursor: pointer;
    color: white;
    background: ${({ theme }) => theme.colors.dark};
  }
`;
